import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Skeleton,
  Button,
} from '@mui/material';
import React from 'react';
import {useGetCurrenciesQuery} from 'api';
import AddIcon from '@mui/icons-material/Add';
import CurrencyDeleteIconButton from './CurrencyDeleteIconButton';
import CreateCurrencyModal from './CurrencyCreateModal';
import CurrencyEditIconButton from './CurrencyEditIconButton';

const totalColumns = 4;

function CurrenciesTable() {
  const {data, isLoading, isError, isSuccess} = useGetCurrenciesQuery();
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      <CreateCurrencyModal
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      />
      <TableContainer component={Paper}>
        <Table sx={{minWidth: 650}} aria-label="Currency Table">
          <TableHead>
            <TableRow>
              <TableCell colSpan={totalColumns - 1}>Currencies</TableCell>
              <TableCell align="right">
                <Button
                  onClick={() => {
                    setIsOpen(true);
                  }}
                  disableElevation
                  variant="contained"
                  endIcon={<AddIcon />}
                >
                  Add
                </Button>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell align="center">Title</TableCell>
              <TableCell align="center">Symbol</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isSuccess &&
              Boolean(data?.length) &&
              data.map(row => (
                <TableRow key={row._id} sx={{'&:last-child td, &:last-child th': {border: 0}}}>
                  <TableCell component="th" scope="row">
                    {row._id}
                  </TableCell>
                  <TableCell align="center">{row.title}</TableCell>
                  <TableCell align="center">{row.symbol}</TableCell>
                  <TableCell align="center">
                    <CurrencyEditIconButton Currency={row} />
                    <CurrencyDeleteIconButton CurrencyId={row._id} />
                  </TableCell>
                </TableRow>
              ))}
            {Boolean(isSuccess && !data?.length) && (
              <TableRow>
                <TableCell colSpan={totalColumns}>No Currency found</TableCell>
              </TableRow>
            )}
            {isError && (
              <TableRow>
                <TableCell colSpan={totalColumns}>
                  <Typography color="error">Failed to fetch Currencies.</Typography>
                </TableCell>
              </TableRow>
            )}
            {isLoading && (
              <TableRow>
                {Array.from(Array(totalColumns).keys()).map(key => (
                  <TableCell key={key}>
                    <Skeleton variant="text" />
                  </TableCell>
                ))}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default CurrenciesTable;
